import { post, put, get, del } from "../fetch.v2"
import { IBadgeCreate } from "../../interfaces/badges"
import { getDomainId, getEventId } from "../../utils/store"

class BadgeApi {
  url: string

  constructor() {
    const domainId = getDomainId()
    const eventId = getEventId()
    this.url = eventId
      ? `/domains/${domainId}/events/${eventId}/badges`
      : `/domains/${domainId}/badges`
  }

  async getAll() {
    return get(this.url)
  }

  async createOne(badge: IBadgeCreate) {
    return post(this.url, badge)
  }

  async getOne(badgeId: number) {
    return get(`${this.url}/${badgeId}`)
  }

  async deleteOne(badgeId: number) {
    return del(`${this.url}/${badgeId}`)
  }

  async updateOne(badgeId: number, badge: Partial<IBadgeCreate>) {
    return put(`${this.url}/${badgeId}`, badge)
  }
}

export default BadgeApi
